'use client'
import Promo from '@/components/header/promo/index';
import NavBar from '@/components/header/nav-bar';
import Menu from '@/components/header/menu';
import React from 'react';
import { usePathname } from 'next/navigation';
function Header() {
  let pathname = usePathname();
  // 如果 pathname 以 /login 开头，不显示 header
  if (pathname?.startsWith('/login')||pathname?.startsWith('/register')) {
    return null;
  }
  
  return (
    <div>
      <Promo />
      <NavBar />
      <Menu />
    </div>
  );
}
export default React.memo(Header);
